import { render } from "./MainTab.vue?vue&type=template&id=81650d42&scoped=true"
import script from "./MainTab.vue?vue&type=script&lang=js"
export * from "./MainTab.vue?vue&type=script&lang=js"

import "./MainTab.vue?vue&type=style&index=0&id=81650d42&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81650d42"]])

export default __exports__